import React, { Component } from 'react';

const NoData = ({ isShowNodata }) => {
    if (isShowNodata) {
        return (
            <div>
                <div className="no-data"></div>
                <div className="tips">该城市下暂无门店</div>
            </div>
          );
    }
    return null;
}

export default NoData;